import { myCertifiedFragment as _myCertifiedFragment } from "ngx-core-services";

export const myCertifiedFragment = _myCertifiedFragment;
